const autores = [
  "García de los Reyes Arquitectos Asociados",
  "Ayuntamiento de Ronda",
]

// ARCHIVOS DEL PROYECTO DEL PLANERO
// Si se despliega el planero en una subcarpeta dentro de un dominio hay que indicar la carpeta
// const PROJECT_BASE_FOLDER = "/planero";
const PROJECT_BASE_FOLDER = "/planero"; 

// URL BASE DE LOS DATOS-CARPETAS PARA LAS TESELAS
const URL_DATA_BASE = 'https://planero.s3.eu-west-3.amazonaws.com';
// const URL_DATA_BASE = '';

// PARA CORS REFERENCIA CATASTRAL - indicar proxy (comprobar que esté montado)
export const PROXY_CATASTRO = 'https://urbanismoronda.es/documentos/proxy?ref&'


export const URL_DATA = `${URL_DATA_BASE}/data`;
export const URL_GEOJSON_DATA = `${URL_DATA}/geojson/geoJson`;

const mapslist = [
 
  {
    id: 1,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V1",
    object: "A_CALIFICACION Y USOS_actualizado_V1",
    type: "tile",
    title: "01. A CALIFICACION Y USOS V1",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-575539.2964258836582303, 4405042.85512366890907288],
    extent: [-576575.2323112782323733 , 4404453.83497465588152409, -574503.36054048920050263, 4405631.87527268193662167],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },
  {
    id: 2,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V2",
    object: "A_CALIFICACION Y USOS_actualizado_V2",
    type: "tile",
    title: "02: A_CALIFICACION Y USOS V2",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-573492.96287986950483173, 4405089.27734130714088678],
    extent: [-574528.80638382153119892, 4404500.46095539070665836, -572457.11937591747846454, 4405678.0937272235751152],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 3,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V3",
    object: "A_CALIFICACION Y USOS_actualizado_V3",
    type: "tile",
    title: "03: A_CALIFICACION Y USOS V3",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-571446.59572236577514559, 4405135.30550738889724016],
    extent: [-572482.34673569409642369, 4404546.69295049272477627, -570410.8447090374538675, 4405723.91806428506970406],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 4,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V4",
    object: "A_CALIFICACION Y USOS_actualizado_V4",
    type: "tile",
    title: "04: A_CALIFICACION Y USOS V4",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-575513.750896135577932, 4403911.43753745406866074],
    extent: [-576549.57753537723328918, 4403322.47950443252921104, -574477.92425689403899014, 4404500.39557047467678785],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 5,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V5",
    object: "A_CALIFICACION Y USOS_actualizado_V5",
    type: "tile",
    title: "05: A_CALIFICACION Y USOS V5",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-573467.63332389062270522, 4403957.84121512714773417],
    extent: [-574503.36758874030783772, 4403369.08692524489015341, -572431.8990590408211574, 4404546.59550500940531492],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 6,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V6",
    object: "A_CALIFICACION Y USOS_actualizado_V6",
    type: "tile",
    title: "06: A_CALIFICACION Y USOS V6",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-575488.30038454220630229, 4402783.89395465329289436],
    extent: [-576524.01818399445619434, 4402194.99780657049268484, -574452.58258508983999491, 4403372.79010273516178131],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 7,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V7",
    object: "A_CALIFICACION Y USOS_actualizado_V7",
    type: "tile",
    title: "07: A_CALIFICACION Y USOS V7",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-573442.31394061539322138, 4402826.52343923877924681],
    extent: [-574477.93901025084778666, 4402237.83122044242918491, -572406.68887097993865609, 4403415.2156580351293087],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 8,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V8",
    object: "A_CALIFICACION Y USOS_actualizado_V8",
    type: "tile",
    title: "08: A_CALIFICACION Y USOS V8",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-575462.69061030331067741, 4401648.95734525285661221],
    extent: [-576498.29888889158610255, 4401060.12346936017274857, -574427.08233171503525227, 4402237.79122114554047585],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 9,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V9",
    object: "A_CALIFICACION Y USOS_actualizado_V9",
    type: "tile",
    title: "09: A_CALIFICACION Y USOS V9",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-573417.00472581200301647, 4401695.32396607473492622],
    extent: [-574452.52064410247839987, 4401106.69379342719912529, -572381.48880752152763307, 4402283.95413872133940458],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 10,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V10",
    object: "A_CALIFICACION Y USOS_actualizado_V10",
    type: "tile",
    title: "10: A_CALIFICACION Y USOS V10",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_10",
    center: [-573391.70567525061778724, 4400564.24274807795882225],
    extent: [-574427.11248604720458388, 4399975.67459665331989527, -572356.29886445414740592, 4401152.81089950259774923],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 11,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V11a",
    object: "A_CALIFICACION Y USOS_actualizado_V11a",
    type: "tile",
    title: "11: A_CALIFICACION Y USOS V11a",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_11",
    center: [-586081.30007686244789511, 4419303.3159042950719595],
    extent: [-586529.34905276703648269, 4419050.46181872021406889, -585633.25110095785930753, 4419556.16998987086117268],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 12,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V11b",
    object: "A_CALIFICACION Y USOS_actualizado_V11b",
    type: "tile",
    title: "12: A_CALIFICACION Y USOS V11b",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_11",
    center: [-571872.43047472962643951, 4413174.52088889945298433],
    extent: [-572321.74199538223911077, 4412841.90129367168992758, -571423.11895407701376826, 4413507.14048412721604109],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 13,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V11c",
    object: "A_CALIFICACION Y USOS_actualizado_V11c",
    type: "tile",
    title: "13: A_CALIFICACION Y USOS V11c",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_11",
    center: [-571512.81514892657287419, 4415140.52001829538494349],
    extent: [-571699.09975844412110746, 4414570.31513437908142805, -571326.53053940914105624, 4415710.72490221168845892],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 14,
    "path": PROJECT_BASE_FOLDER + "/A_CALIFICACION Y USOS_actualizado_V11d",
    object: "A_CALIFICACION Y USOS_actualizado_V11d",
    type: "tile",
    title: "14: A_CALIFICACION Y USOS V11d",
    imgLegend: "A_vertical",
    imgLegendGeneral: "A_logov1_11",
    center: [-569760.09613566310144961, 4408410.68967922031879425],
    extent: [-570175.62932680756784976, 4407835.78404855635017157, -569344.56294451863504946, 4408985.59530988335609436],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 15,
    "path": PROJECT_BASE_FOLDER + "/B_CLASIFICACION TM_actualizado_V1",
    object: "B_CLASIFICACION TM_actualizado_V1",
    type: "tile",
    title: "15: B_CLASIFICACION TM V1",
    imgLegend: "B_vertical",
    imgLegendGeneral: "B_logo_v1",
    center: [-572353.75920826126821339, 4419206.0364492442458868],
    extent: [-588971.08154080156236887, 4410075.45236903801560402, -555736.43687572085764259, 4428336.62052945140749216],
    zoom: 12,
    minZoom: 12,
    maxZoom: 16,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 16,
    "path": PROJECT_BASE_FOLDER + "/B_CLASIFICACION TM_actualizado_V2",
    object: "B_CLASIFICACION TM_actualizado_V2",
    type: "tile",
    title: "16: B_CLASIFICACION TM V2",
    imgLegend: "B_vertical",
    imgLegendGeneral: "B_logo_v2",
    center: [-572987.71125037712045014, 4402065.46408101357519627],
    extent: [-589577.34214380802586675, 4392949.51133275590837002, -556398.08035694621503353, 4411181.41682927217334509],
    zoom: 12,
    minZoom: 12,
    maxZoom: 16,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 17,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V1",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V1",
    type: "tile",
    title: "17: E_ORDENACION ESTRUCTURAL V1",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v1",
    center: [-574012.80227237357757986, 4402890.15788963623344898],
    extent: [-576897.78830318141262978, 4399547.8768005883321166, -571127.81624156585894525, 4406232.43897868320345879],
    zoom: 12,
    minZoom: 12,
    maxZoom: 18,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 18,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V2a",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V2a",
    type: "tile",
    title: "18: E_ORDENACION ESTRUCTURAL V2a",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v2",
    center: [-566218.05611110432073474, 4412773.5866246810182929],
    extent: [-571974.45248552621342242, 4406085.51762951165437698, -560461.65973668254446238, 4419461.65561985038220882],
    zoom: 12,
    minZoom: 12,
    maxZoom: 18,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 19,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V2b",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V2b",
    type: "tile",
    title: "19: E_ORDENACION ESTRUCTURAL V2b",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v2",
    center: [-586049.44853259017691016, 4419287.61960702855139971],
    extent: [-586553.73521908896509558, 4418774.58806469477713108, -585545.16184609138872474, 4419800.65114936232566833],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 20,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V2c",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V2c",
    type: "tile",
    title: "20: E_ORDENACION ESTRUCTURAL V2c",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v2",
    center: [-571500.96581333235371858, 4415133.88728449586778879],
    extent: [-572004.42512709461152554, 4414621.68827722780406475, -570997.50649957009591162, 4415646.08629176393151283],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },
  

  {
    id: 21,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V2d",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V2d",
    type: "tile",
    title: "21: E_ORDENACION ESTRUCTURAL V2d",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v2",
    center: [-571872.71118793962523341, 4413170.51091944612562656],
    extent: [-572376.07782881334424019, 4412658.40619380120187998, -571369.34454706578981131, 4413682.61564509011805058],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },

  {
    id: 22,
    "path": PROJECT_BASE_FOLDER + "/E_ORDENACION ESTRUCTURAL_actualizado_V2e",
    object: "E_ORDENACION ESTRUCTURAL_actualizado_V2e",
    type: "tile",
    title: "22: E_ORDENACION ESTRUCTURAL V2e",
    imgLegend: "E_vertical",
    imgLegendGeneral: "E_logo_v2",
    center: [-569707.95360914978664368, 4408399.9027805719524622],
    extent: [-570210.9695046516135335, 4407888.15029320120811462, -569204.93771364795975387, 4408911.65526794362813234],
    zoom: 14,
    minZoom: 14,
    maxZoom: 19,
    addvector: false,
    cadastre: "spain",
    base: [],
    authors: autores,
  },
];

export default mapslist;
